import { Skeleton, Divider } from 'antd';
import { RadioGroup } from 'features/search/styled';
import styled from 'styled-components';

export const Title = styled.h4`
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  color: #333333;
  margin: 0 0 20px;
`;

export const MethodGroup = styled(RadioGroup)`
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
  gap: 16px;

  & > button {
    padding: 16px;
    border: 1px solid #f1f1f1;
    border-radius: 6px;
    gap: 16px;
  }
`;

export const MethodItem = styled.button`
  background: none;
  border: none;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  text-align: left;
  cursor: pointer;

  & > .ant-radio-wrapper {
    display: block;
    margin: 0;
  }

  .activate-daytrade {
    color: #00ab6b;
  }

  .disabled-daytrade {
    color: #b5b5b5;
  }

  :disabled {
    cursor: not-allowed;
  }
`;

export const MethodItemButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const MethodTextContent = styled.div`
  width: 100%;
`;

export const MethodTitleSkeleton = styled(Skeleton.Button)`
  & span.ant-skeleton-button {
    width: 100px;
    height: 22px;
  }
`;

export const MethodTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 4px;

  & > div,
  button {
    margin-left: 8px;
  }

  .multiplier-chip {
    font-size: 14px;
    line-height: 19px;
    border-color: #f2f1fe;
    background-color: #f2f1fe;
    color: #8277f8;
    padding: 2px 8px;
    display: flex;
    gap: 2px;
  }
`;

interface MethodTitleProps {
  disabled?: boolean;
}

export const MethodTitle = styled.p<MethodTitleProps>`
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  color: #333333;

  margin: 0;

  ${({ disabled }) =>
    disabled &&
    `
    color: #B5B5B5;
  `}
`;

export const MethodDescription = styled.p`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #969696;

  margin: 0;
  width: 88%;
`;

export const ChipsButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`;

export const LeverageInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  max-width: 460px;
  font-size: 14px;
  color: #333333;
  cursor: default;
  gap: 8px;
`;

export const InfoRow = styled.div<{isBold?: boolean}>`
  display: flex;
  justify-content: space-between;
  width: 100%;

  span {
    font-weight: ${({ isBold }) => (isBold ? '700' : '400')};
  }
`;

export const DividerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 0;
`;

export const RowDivider = styled(Divider)`
  margin: 10px 0;
  width: 50%;
  min-width: unset;
`;

export const SymbolChip = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 0 6px;
  border-radius: 8px;
  border: 1px solid #f2f1fe;
  height: 18px;
  background-color: #f2f1fe;
  color: #8277f8;
`;

export const BuyingPowerWording = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .multiplier-chip {
    font-size: 14px;
    line-height: 19px;
    border-color: #f2f1fe;
    background-color: #f2f1fe;
    color: #8277f8;
    padding: 2px 8px;
    display: flex;
    gap: 2px;
  }
`;

export const ChipSkeleton = styled(Skeleton.Button)`
  & span.ant-skeleton-button {
    width: 60px;
    height: 22px;
  }
`;

export const PriceSkeleton = styled(ChipSkeleton)`
  & span.ant-skeleton-button {
    width: 100px;
    height: 22px;
  }
`;
